import React, { useState } from "react";
import enquiryFormAPI from "../../api/enquiryForm";
import { showSuccess, showError } from "../../utils/toastUtils";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";

const EnquiryForm = () => {
  useAlphabeticInput();
  useNumericInput();

  const INITIAL_FORM_DATA = {
    Parentsname: "",
    email: "",
    phone: "",
    class: "",
    message: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);
  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please enter email address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.phone) {
      newErrors.phone = "Please enter phone";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone must be 10 digits";
    }

    if (!formData.Parentsname.trim()) {
      newErrors.Parentsname = "Please enter parent's name";
    } else if (!/^[A-Za-z\s]+$/.test(formData.Parentsname.trim())) {
      newErrors.Parentsname =
        "Parent's name can contain only letters and spaces";
    }

    if (!formData.class.trim()) {
      newErrors.class = "Please enter class";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Please enter message";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setLoading(true);
    try {
      const res = await enquiryFormAPI.enquiry_form(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        setFormData(INITIAL_FORM_DATA);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // classes
  const classes = [
    "Nursery",
    "LKG",
    "UKG",
    "Class 1",
    "Class 2",
    "Class 3",
    "Class 4",
    "Class 5",
    "Class 6",
    "Class 7",
    "Class 8",
    "Class 9",
    "Class 10",
    "Class 11",
    "Class 12",
  ];

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <input
              type="text"
              name="Parentsname"
              className="form-control only-alphabets"
              placeholder="Parent's Name"
              value={formData.Parentsname}
              onChange={handleChange}
              required
            />
            {errors.Parentsname && (
              <span className="text-danger">{errors.Parentsname}</span>
            )}
          </div>
          <div className="col-md-6">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && (
              <span className="text-danger">{errors.email}</span>
            )}
          </div>
          <div className="col-md-6">
            <input
              type="text"
              name="phone"
              maxLength={10}
              className="form-control only-numeric"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            {errors.phone && (
              <span className="text-danger">{errors.phone}</span>
            )}
          </div>
          <div className="col-md-6">
            {/* <input
              type="text"
              name="class"
              className="form-control"
              placeholder="Enter class"
              value={formData.class}
              onChange={handleChange}
              required
            /> */}
            <select
              name="class"
              className="form-control enquire-dropdown"
              value={formData.class}
              onChange={handleChange}
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option key={cls} value={cls}>
                  {cls}
                </option>
              ))}
            </select>
            {errors.class && (
              <span className="text-danger">{errors.class}</span>
            )}
          </div>

          <div className="col-12">
            <textarea
              className="form-control"
              type="text"
              name="message"
              rows={3}
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            {errors.message && (
              <span className="text-danger">{errors.message}</span>
            )}
          </div>
          <div className="col-12">
            <button
              type="submit"
              disabled={loading}
              className="btn mrv-btn-outline w-100 rounded-0"
            >
              {loading ? "Submitting..." : "SUBMIT ENQUIRY"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EnquiryForm;
